import { t } from '@lingui/core/macro'
import { useMemo, useState } from 'react'
import ECharts from '~/components/echarts'
import Filters from '~/dashboard/azure_storage_dashboard_filters'
import {
  azureMonthlyCostsByDiskTypeQueryChartPath,
  azureStorageQuantityByDiskStateQueryChartPath,
  azureStorageQuantityByDiskTypeQueryChartPath,
} from '~/routes'

export default function AzureStorageDashboardCharts({ organizationId: orgId }) {
  const [params, setParams] = useState({ azureCostKind: 'ActualCost' })

  const quantityByDiskType = useMemo(() => azureStorageQuantityByDiskTypeQueryChartPath(orgId), [orgId])
  const quantityByDiskState = useMemo(() => azureStorageQuantityByDiskStateQueryChartPath(orgId), [orgId])
  const monthlyCostsByDiskType = useMemo(() => azureMonthlyCostsByDiskTypeQueryChartPath(orgId), [orgId])

  return (
    <div className='card'>
      <div className='card-body'>
        <Filters organizationId={orgId} setChartParams={setParams} />
        <div className='row g-0'>
          <div className='col-sm-6'>
            <ECharts
              title={t`Quantity By Disks Types`}
              chartInfoTitle='azure_storage_quantity_by_disks_types'
              url={quantityByDiskType}
              params={params}
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`Quantity By Disks States`}
              chartInfoTitle='azure_storage_quantity_by_disks_states'
              url={quantityByDiskState}
              params={params}
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`Monthly Costs By Disk Types`}
              chartInfoTitle='azure_storage_monthly_costs_by_disk_types'
              url={monthlyCostsByDiskType}
              params={params}
              showExportButton
            />
          </div>
        </div>
      </div>
    </div>
  )
}
